export const AVATAR_URL =
    "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80";

export const FileSizeERR = "Image size must be under 150KB";
export const FileInvalidERR =
    "File type must be: [image/jpeg, image/png, image/jpg]";
export const ERR_MSG = "There is something went wrong!";
export const POST_PUBLISHED = "Your post has been published!";
